import axios from "axios";
import { AvcUrl, BaseUrl } from "../../../Container/BaseUrl/BaseUrl";
import { useDispatch } from "react-redux";
import { UpdateExternalContactList } from "../../../Redux/Actions/actions.js";

export const DummyReport = (reportType, callDetails) => {
  let Data = null;
  switch (reportType) {
    case "hold_call":
      Data = {
        type: "hold",
        contactId: callDetails.contactId,
      };
      break;
    case "unhold_call":
      Data = {
        type: "unhold",
        contactId: callDetails.contactId,
      };
      break;
    case "completeTransfer":
      Data = {
        type: "completetransfer",
        contactId: callDetails.contactId,
        consultedId: callDetails.consultedId,
        chatsessionid: callDetails.chatsessionid,
      };
      break;
    case "completeconference":
      Data = {
        type: "completeconference",
        contactId: callDetails.contactId,
        consultedId: callDetails.consultedId,
        chatsessionid: callDetails.chatsessionid,
      };
      break;
    case "callEnd":
      Data = {
        type: "endcall",
        contactId: callDetails.contactId,
        endType: callDetails.endType,
      };
      break;
    default:
      Data = {};
      break;
  }
  axios.post(BaseUrl + "/reports/dummyreport", Data, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
      tenantid: localStorage.getItem("TenantId"),
    },
  });
};

export const end_call = async () => {
  let AvcUrl = localStorage.getItem("AvcUrl");
  let contactId = localStorage.getItem("contactId");
  let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
  await axios
    .post(
      AvcUrl +
        `/voice/terminal/${agentLoginTerminalId}/disconnect/` +
        contactId,
      {},
      {
        headers: {
          ssoToken: localStorage.getItem("ssoToken"),
        },
      }
    )
    .then((res) => {
      localStorage.removeItem("contactId");
    })
    .catch((err) => {
      localStorage.removeItem("contactId");
    });
};

export const useCompleted = () => {
  const dispatch = useDispatch();
  const completed = async (reason) => {
    try {
      let selectedChat = JSON.parse(localStorage.getItem("client"));
      await axios
        .post(
          BaseUrl + "/contact/updatecampaignDetails",
          {
            contactid: localStorage.getItem("clickToCallCallerID"),
            status: reason,
            chat_session_id: selectedChat.chat_session_id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          dispatch(UpdateExternalContactList(selectedChat.chat_session_id));
        })
        .catch((err) => {});
    } catch (error) {
      console.log("completedCampaign error:", error);
    }
  };
  return completed;
};
export const useCompletedCampaign = () => {
  const dispatch = useDispatch();

  const completedCampaign = async (reason) => {
    try {
      let selectedChat = JSON.parse(localStorage.getItem("client"));
      await axios
        .post(
          BaseUrl + "/contact/updatecampaign",
          {
            contactid: localStorage.getItem("clickToCallCallerID"),
            status: reason,
            chat_session_id: selectedChat.chat_session_id,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "application/json",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        )
        .then((res) => {
          dispatch(UpdateExternalContactList(selectedChat.chat_session_id));
        })
        .catch((err) => {
          console.log("completedCampaign error:", err);
        });
    } catch (error) {
      console.log("completedCampaign error:", error);
    }
  };

  return completedCampaign;
};
